export default {
      staking: {
        1: "0x3C01c6c58E61Ae5fFc0e603abd7ebe5d9d27D97a",
        4: "0x3C01c6c58E61Ae5fFc0e603abd7ebe5d9d27D97a",
      },
      ape: {
        1: "0x73fd64feed39ba564326ac4327b90596a2056404",
        4: "0xf7bb1667c9b413e7d473218daf24e65c28327fb8",
      },
      variable: {
        1: "0xAD93D504631feCA691d0a6EFed72f8344Ee72925",
        4: "0xAD93D504631feCA691d0a6EFed72f8344Ee72925",
      },
    standard: {
        1: "0xe559525118f9Ae71e2b21806B15332D17A00EBfF",
        4: "0xe559525118f9Ae71e2b21806B15332D17A00EBfF",
    },
  };
  